/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const BreadcrumbItemStyled = styled.span({
  '& span': {
    fontWeight: token('font.weight.regular'),
  },
});
